import React from "react";
import { Row, Col } from "react-grid-system";
import { ICustomer } from "dataModels/contract";
import { ClientType } from "shared/constants";
import { useTranslation } from "react-i18next";
import { Output } from "@ds/ds-snam/react";

interface ICustomerFormReviewProps {
    formData: ICustomer;
}
const CustomerFormReview: React.FC<ICustomerFormReviewProps> = (props): JSX.Element => {
    const { t } = useTranslation(['contract', 'app']);

    const { formData } = props;
    const replaceEmpty = (value: string): string => {
        return value.length ? value : "-";
    }
    return (<>

        {/** Company info */}
        <Row style={{ marginBottom: "12px" }}>
            <Col>
                <div className="box">
                    <div className="pageSemiTitle">
                        {t('customer.customerForm.sections.review.companyInfoTitle', { ns: 'contract' })}
                    </div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.1')}
                                outputText={formData.businessName}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.9')}
                                outputText={formData.businessEmail}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.14')}
                                outputText={formData.businessCode}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.1')}</p>
                            <p className="boxFieldData">{formData.businessName}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.9')}</p>
                            <p className="boxFieldData">{formData.businessEmail}</p>*/}

                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.2')}
                                outputText={formData.businessSecondName}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.10')}
                                outputText={formData.billingPec}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.2')}</p>
                            <p className="boxFieldData">{formData.businessSecondName}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.10')}</p>
                            <p className="boxFieldData">{formData.billingPec}</p>*/}
                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.3')}
                                outputText={formData.businessAddress + " " + formData.businessStreetNumber}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {formData.clientType === ClientType.IT && <>
                                <Output
                                    outputTitle={t('customer.customerForm.sections.info.fields.11')}
                                    outputText={formData.inipec}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            </>}
                            {formData.clientType !== ClientType.IT && <>
                                <Output
                                    outputTitle={t('customer.customerForm.sections.info.fields.13')}
                                    outputText={formData.billingEmail}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            </>}
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.3')}</p>
                            <p className="boxFieldData">{formData.businessAddress} {formData.businessStreetNumber}</p>
                            {formData.clientType === ClientType.IT && <>
                                <p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.11')}</p>
                                <p className="boxFieldData">{formData.inipec}</p>
                            </>}
                            {formData.clientType !== ClientType.IT && <>
                                <p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.13')}</p>
                                <p className="boxFieldData">{formData.billingEmail}</p>
                            </>}*/}
                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.5')}
                                outputText={formData.businessPostalCode+" "+formData.businessCity+" "+formData.businessProvince+" "+formData.businessState}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.info.fields.12')}
                                outputText={formData.recipientCode}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.5')}</p>
                            <p className="boxFieldData">{formData.businessPostalCode} {formData.businessCity} {formData.businessProvince} {formData.businessState}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.info.fields.12')}</p>
                            <p className="boxFieldData">{formData.recipientCode}</p>*/}
                        </div>
                    </div>
                </div>
            </Col>
        </Row>

        {/** Fiscal */}
        <Row style={{ marginBottom: "12px" }}>
            {/** Fiscal data */}
            <Col xs={12} md={6} style={{paddingRight:'0px'}}>
                <div className="box" style={{height:"250px"}}>
                    <div className="pageSemiTitle">{t('customer.customerForm.sections.fiscalData.title')}</div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={formData.clientType === ClientType.IT ? t('customer.customerForm.sections.fiscalData.fields.0') : t('customer.customerForm.sections.fiscalData.fields.4')}
                                outputText={formData.clientType === ClientType.IT ? formData.fiscalCode : formData.vatCee}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalData.fields.2')}
                                outputText={replaceEmpty(formData.vatGroup)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{formData.clientType === ClientType.IT ? t('customer.customerForm.sections.fiscalData.fields.0') : t('customer.customerForm.sections.fiscalData.fields.4')}</p>
                            <p className="boxFieldData">{formData.clientType === ClientType.IT ? formData.fiscalCode : formData.vatCee}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalData.fields.2')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.vatGroup)}</p>*/}
                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={formData.clientType === ClientType.IT ? t('customer.customerForm.sections.fiscalData.fields.1') : t('customer.customerForm.sections.fiscalData.fields.5')}
                                outputText={formData.clientType === ClientType.IT ? formData.vat : formData.vatExtrCee}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalData.fields.3')}
                                outputText={formData.splitPayment === true ? t('general.yesLabel', { ns: 'app' }) : t('general.noLabel', { ns: 'app' })}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{formData.clientType === ClientType.IT ? t('customer.customerForm.sections.fiscalData.fields.1') : t('customer.customerForm.sections.fiscalData.fields.5')}</p>
                            <p className="boxFieldData">{formData.clientType === ClientType.IT ? formData.vat : formData.vatExtrCee}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalData.fields.3')}</p>
                            <p className="boxFieldData">{formData.splitPayment === true ? t('general.yesLabel', { ns: 'app' }) : t('general.noLabel', { ns: 'app' })}</p>*/}
                        </div>
                    </div>
                </div>
            </Col>

            {/** Fiscal Rapresentative */}
            <Col xs={12} md={6}>
                <div className="box" style={{height:"250px"}}>
                    <div className="pageSemiTitle">{t('customer.customerForm.sections.fiscalRepr.title')}</div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalRepr.fields.0')}
                                outputText={replaceEmpty(formData.taxAgentDenomination)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalRepr.fields.2')}
                                outputText={replaceEmpty(formData.taxAgentFirstName)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalRepr.fields.4')}
                                outputText={replaceEmpty(formData.taxAgentState)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalRepr.fields.0')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.taxAgentDenomination)}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalRepr.fields.2')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.taxAgentFirstName)}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalRepr.fields.4')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.taxAgentState)}</p>*/}
                        </div>
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalRepr.fields.1')}
                                outputText={replaceEmpty(formData.taxAgentVat)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            <Output
                                outputTitle={t('customer.customerForm.sections.fiscalRepr.fields.3')}
                                outputText={replaceEmpty(formData.taxAgentSecondName)}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalRepr.fields.1')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.taxAgentVat)}</p>
                            <p className="boxFieldLabel">{t('customer.customerForm.sections.fiscalRepr.fields.3')}</p>
                            <p className="boxFieldData">{replaceEmpty(formData.taxAgentSecondName)}</p>*/}
                        </div>
                    </div>
                </div>
            </Col>
        </Row>

        <Row style={{ marginBottom: "12px" }}>
            <Col>
                <div className="box">
                    <div className="pageSemiTitle">{t('customer.customerForm.sections.bank.title')}</div>
                    <div className="boxContent">
                        <div className="boxContentColumn">
                            <Output
                                outputTitle={t('customer.customerForm.sections.bank.fields.0')}
                                outputText={formData.bankIban}
                            style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.bank.fields.0')}</p>
                            <p className="boxFieldData">{formData.bankIban}</p>*/}
                        </div>
                        {formData.clientType === ClientType.EXTRA_UE && <>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('customer.customerForm.sections.bank.fields.1')}
                                    outputText={formData.bankState}
                                style={{marginBottom:'16px'}}
                            ></Output>
                                {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.bank.fields.1')}</p>
                                <p className="boxFieldData">{formData.bankState}</p>*/}
                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('customer.customerForm.sections.bank.fields.2')}
                                    outputText={formData.bankAccount}
                                style={{marginBottom:'16px'}}
                            ></Output>
                                {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.bank.fields.2')}</p>
                                <p className="boxFieldData">{formData.bankAccount}</p>*/}
                            </div>
                        </>}
                        {formData.clientType !== ClientType.IT && <>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('customer.customerForm.sections.bank.fields.3')}
                                    outputText={formData.bankSwift}
                                style={{marginBottom:'16px'}}
                            ></Output>
                                {/*<p className="boxFieldLabel">{t('customer.customerForm.sections.bank.fields.3')}</p>
                                <p className="boxFieldData">{formData.bankSwift}</p>*/}
                            </div>
                        </>}
                    </div>
                </div>
            </Col>
        </Row>
    </>)
}
export default CustomerFormReview;